import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import JobDetail from './JobDetails';
import JobNote from './JobNotes';
import JobQuote from './JobQuote';
import JobQuoteHistoryData from './JobQuoteHistory';
import JobSchedule from './JobSchedule';
import JobPhotosData from './JobPhotos';
import JobFilesData from './JobFiles';
import JobInvoice from './JobInvoices';
import authService from './api-authorization/AuthorizeService';

interface Job {
    id?: number;
    systemCompanyId: number;
    customers: CustomerList[];
    jobDetails: JobDetails;
    yesNo: GenericList[];
    jobTypes: GenericList[];
    statusOptions: GenericList[];
    branches: Branch[];
    tab: string;
    canViewInvoices: boolean;
    canReopenJob: boolean;
    canCancelJob: boolean;
    canUnlockJob: boolean;
    loading: boolean;
}

interface GenericList {
    id: number;
    name: string;
}

interface CustomerList {
    id: number;
    name: string;
    gateCode: string;
    accountId: string;
    accountIdDunny: string;
    accountTypeId: number;
    accountType: string;
    accountLimitFormatted: string;
    allowOnGoingHire: boolean;
    quoteNotesDunny: string;
    canEmailCustomer: boolean;
    cashSaleAccount: boolean;
    invoiceQuotedAmount: boolean;
    chargeFuelSurcharge: boolean;
    newFuelInvoice: boolean;
    statusTypeId: number;
    locked: boolean;
}

interface INameToValueMap {
    [key: string]: any;
}

//reusing wizard steps so need this
interface JobDetails {
    id: number;
    companyId: number;
    copyJobId: number;
    customerId?: number;
    customer: string;
    customerExists: boolean;
    customerContactFirstName: string;
    customerContactLastName: string;
    customerContactPhone: string;
    customerContactEmail: string;
    customerAddress: string;
    customerStreetNumber: string;
    customerStreetName: string;
    customerSuburb: string;
    customerState: string;
    customerCountry: string;
    customerPostCode: string;
    customerGooglePlaceId: string;
    customerAddressLatitude: number;
    customerAddressLongitude: number;
    customerAbn: string;
    customerContactId?: number;
    customerCashSaleAccount: boolean;
    customerInvoiceQuotedAmount: boolean;
    customerChargeFuelSurcharge: boolean;
    customerNewFuelInvoice: boolean;
    useTyabbPricelist: boolean;
    sendEmailToCustomer: boolean;
    customerContactEmailConfirmed: boolean;
    accountTypeId: number;
    accountType: string;
    accountLimitFormatted: string;
    customerAllowOnGoingHire: boolean;
    customerQuoteNotesDunny: string;
    siteAddressExists: boolean;
    siteAddress: string;
    siteAddressDistance: number;
    siteAddressDistanceFormatted: string;
    siteAddressDuration: number;
    siteAddressDurationFormatted: string;
    addressNearSiteAddress: string;
    unitNumber: string;
    streetNumber: string;
    streetName: string;
    suburb: string;
    state: string;
    country: string;
    postCode: string;
    manualStreetName: string;
    manualSuburb: string;
    manualState: string;
    manualCountry: string;
    manualPostCode: string;
    lotNumber: string;
    googlePlaceId: string;
    siteAddressLatitude: number;
    siteAddressLongitude: number;
    addressGooglePlaceId: string;
    addressSiteAddressLatitude: number;
    addressSiteAddressLongitude: number;
    addressSiteAddressDistance: number;
    addressSiteAddressDistanceFormatted: string;
    addressSiteAddressDuration: number;
    addressSiteAddressDurationFormatted: string;
    closestBranchId: number;
    isEvent: boolean;
    isThreeDayHire: boolean;
    eventName: string;
    eventStartDate: string;
    eventEndDate: string;
    deliveryWindowStart: string;
    deliveryWindowEnd: string;
    deliveryPlacementNotes: string;
    jobType: number;
    paymentType: number;
    gateCode: string;
    truckAccess: number;
    parking: number;
    siteClean: number;
    powerlinesWithinRange: number;
    weekdayAccess: number;
    weekendAccess: number;
    phoneCallRequired: number;
    statusId: number;
    notes: string;
    copyQuote: boolean;
    linkJob: boolean;
    linkedToReckon: boolean;
    locked: boolean;
    reference: string;
    priceOnly: boolean; //Not used for existing job - allows user just to get a price for the cusotmer not create a job
    goAheadOverride: boolean;   //allows the job to goahead even if the customer id locked
}

interface SiteContacts {
    siteContactName: string;
    siteContactPhone: string;
    siteContact2: string;
}

interface Branch {
    id: number;
    name: string;
    fullAddress: string;
    scheduleBranchId: number;
}

export class JobData extends React.Component<RouteComponentProps<{}>, Job> {
    constructor(props: any) {
        super(props);

        this.state = {
            systemCompanyId: 0,
            jobDetails: {
                id: 0,
                companyId: 0,
                copyJobId: 0,
                customer: "",
                customerExists: true,
                customerContactFirstName: "",
                customerContactLastName: "",
                customerContactPhone: "",
                customerContactEmail: "",
                customerAddress: "",
                customerStreetNumber: "",
                customerStreetName: "",
                customerSuburb: "",
                customerState: "",
                customerCountry: "",
                customerPostCode: "",
                customerGooglePlaceId: "",
                customerAddressLatitude: 0,
                customerAddressLongitude: 0,
                customerAbn: "",
                customerContactEmailConfirmed: true,
                customerContactId: -1,
                customerId: -1,
                customerCashSaleAccount: false,
                customerInvoiceQuotedAmount: false,
                customerChargeFuelSurcharge: true,
                customerNewFuelInvoice: false,
                useTyabbPricelist: false,
                sendEmailToCustomer: true,
                accountTypeId: -1,
                accountType: "",
                accountLimitFormatted: "",
                customerAllowOnGoingHire: true,
                customerQuoteNotesDunny: "",
                siteAddressExists: true,
                siteAddress: "",
                siteAddressDistance: 0,
                siteAddressDistanceFormatted: "",
                siteAddressDuration: 0,
                siteAddressDurationFormatted: "",
                addressNearSiteAddress: "",
                unitNumber: "",
                streetNumber: "",
                streetName: "",
                suburb: "",
                state: "",
                country: "",
                postCode: "",
                manualStreetName: "",
                manualSuburb: "",
                manualState: "VIC",
                manualCountry: "Australia",
                manualPostCode: "",
                lotNumber: "",
                isEvent: false,
                isThreeDayHire: false,
                eventName: "",
                eventStartDate: "",
                eventEndDate: "",
                deliveryWindowStart: "",
                deliveryWindowEnd: "",
                deliveryPlacementNotes: "",
                jobType: -1,
                paymentType: -1,
                gateCode: "",
                notes: "",
                copyQuote: false,
                linkJob: false,
                googlePlaceId: "",
                siteAddressLatitude: 0,
                siteAddressLongitude: 0,
                addressGooglePlaceId: "",
                addressSiteAddressLatitude: 0,
                addressSiteAddressLongitude: 0,
                addressSiteAddressDistance: 0,
                addressSiteAddressDistanceFormatted: "",
                addressSiteAddressDuration: 0,
                addressSiteAddressDurationFormatted: "",
                closestBranchId: 1,
                truckAccess: -1,
                parking: -1,
                siteClean: -1,
                powerlinesWithinRange: -1,
                weekdayAccess: -1,
                weekendAccess: -1,
                phoneCallRequired: -1,
                linkedToReckon: true,
                locked: false,
                statusId: 1,
                reference: "",
                priceOnly: false,
                goAheadOverride: false
            },
            customers: [],
            yesNo: [],
            jobTypes: [],
            statusOptions: [],
            branches: [],
            tab: "Details",
            canViewInvoices: false,
            canReopenJob: false,
            canCancelJob: false,
            canUnlockJob: false,
            loading: true
        }
    }

    componentDidMount() {
        let jobParams: INameToValueMap = {};
        jobParams["id"] = 0;
        jobParams["files"] = "";
        jobParams = this.props.match.params;
        let Id = jobParams["id"];
        let files = jobParams["files"] ?? "";
        this.setState({ id: Id });

        this.getData(Id, files);
    }

    async getData(id: number, files: string) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //defaulting JobTypeId to 1 as that will set it to get ALL customers
        axios.get('api/Job/GetDropdowns?JobId=' + id + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ id: id, branches: res.data.branchOptions, systemCompanyId: res.data.systemCompanyId, customers: res.data.customers, yesNo: res.data.yesNo, jobTypes: res.data.jobTypes, statusOptions: res.data.statusOptions, canViewInvoices: res.data.canViewInvoices, canReopenJob: res.data.canReopenJobs, canCancelJob: res.data.canCancelJob, canUnlockJob: res.data.canUnlockJob });

            this.getJobDetails(id, files);
        })
    }

    getJobDetails = async (id: number, files: string) => {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetJobDetails?jobId=' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ jobDetails: res.data, loading: false });
            if (files != "") {
                this.setState({ tab: "Files" });
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    copyJob = () => {
        var jobTypeId = this.state.jobDetails.jobType;
        var copyId = this.state.id;
        this.props.history.push("/newjob/" + jobTypeId + "/" + copyId);
    }

    openNewJob = (newJobId: number) => {
        var url = "/job/" + newJobId;
        window.open(url);
    }

    tabSelected = (tab: string) => {
        this.setState({ tab: tab });
    }

    tabChanged = (e: any) => {
        this.tabSelected(e.target.value);
    }

    noChange = (e: any) => {
        //no changes as user doesn't actually click on the radio button
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    reloadJobDetails = () => {
        this.getJobDetails(this.state.jobDetails.id, "");
    }

    updateJobDetails = (jobDetails: JobDetails, resetItems: boolean) => {
        //reset data used for new jobs not existing
        //save the data to state - so we can pass to other items
        this.setState({ jobDetails: jobDetails });
    }

    saveJobDetails = () => {
        this.saveJob();
    }

    async saveJob() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var jobDetails = this.state.jobDetails;

        var saveJob = {
            jobDetails: jobDetails,
            subId: user.sub
        };

        axios.post('api/Job/SaveJobDetails', saveJob, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Job Saved");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    _prev = (data: any) => {

    }

    updateSiteContacts = (siteContacts: SiteContacts) => {
        //not used on job screen as can't change customer
    }

    updatePaymentType = (accountTypeId: number) => {
        //not used on job screen as can't change customer
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderJob();

        let SiteAddress = this.state.jobDetails.unitNumber ? this.state.jobDetails.unitNumber + "/" + this.state.jobDetails.siteAddress : this.state.jobDetails.siteAddress;

        return <div>
            <h1>{this.state.id} - {SiteAddress}</h1>
            {contents}
        </div>;
    }

    renderJob = () => {
        
        var contents;
        if (this.state.tab == "Details" && this.state.jobDetails.id) {
            let siteContacts: SiteContacts = {
                siteContactName: "",
                siteContactPhone: "",
                siteContact2: ""
            };
            contents = <JobDetail currentStep={1} jobDetails={this.state.jobDetails} siteContacts={siteContacts} systemCompanyId={this.state.systemCompanyId} customers={this.state.customers} yesNo={this.state.yesNo} jobTypes={this.state.jobTypes} statusOptions={this.state.statusOptions} branches={this.state.branches} copyJob={false} canReopenJob={this.state.canReopenJob} canCancelJob={this.state.canCancelJob} canUnlockJob={this.state.canUnlockJob} save={this.saveJobDetails} reloadJobDetails={this.reloadJobDetails} update={this.updateJobDetails} updateSiteContacts={this.updateSiteContacts} updatePaymentType={this.updatePaymentType} openNewJob={this.openNewJob} />
        }
        else if (this.state.tab == "Quote" && this.state.jobDetails.id) {
            contents = <JobQuote jobId={this.state.jobDetails.id} systemCompanyId={this.state.systemCompanyId} jobTypeId={(this.state.jobDetails.jobType * 1)} siteAddress={this.state.jobDetails.siteAddress} customerId={this.state.jobDetails.customerId} copyJob={this.copyJob} veiwQuoteHistory={this.tabSelected} />
        }
        else if (this.state.tab == "QuoteHistory" && this.state.jobDetails.id) {
            contents = <JobQuoteHistoryData jobId={this.state.jobDetails.id} systemCompanyId={this.state.systemCompanyId} siteAddress={this.state.jobDetails.siteAddress} goQuote={this.tabSelected} />
        }
        else if (this.state.tab == "Schedule" && this.state.jobDetails.id) {
            contents = <JobSchedule systemCompanyId={this.state.systemCompanyId} jobId={this.state.jobDetails.id} jobTypeId={this.state.jobDetails.jobType * 1} jobStatusId={this.state.jobDetails.statusId } />
        }
        else if (this.state.tab == "Photos" && this.state.jobDetails.id) {
            contents = <JobPhotosData jobId={this.state.jobDetails.id } />
        }
        else if (this.state.tab == "Files" && this.state.jobDetails.id) {
            contents = <JobFilesData jobId={this.state.jobDetails.id } />
        }
        else if (this.state.tab == "Invoices" && this.state.jobDetails.id && this.state.canViewInvoices) {
            contents = <JobInvoice jobId={this.state.jobDetails.id} jobStatusId={this.state.jobDetails.statusId} isEvent={this.state.jobDetails.isEvent} isThreeDayHire={this.state.jobDetails.isThreeDayHire } />
        }
        else if (this.state.tab == "Notes" && this.state.jobDetails.id) {
            contents = <JobNote jobId={this.state.jobDetails.id} />
        }

        return (
            <div>
                <div className="tabsComponent" id="tab-container">

                    <div className="tabsComponent__showDropdown">
                        <label className="input-group" htmlFor="jobTab">
                            <span className="label">Item Type</span>
                            <select className="select" id="jobTab" value={this.state.tab} onChange={this.tabChanged} >
                                <option value="Details">Details</option>
                                <option value="Quote">Quote</option>
                                <option value="Schedule">Schedule</option>
                                <option value="Photos">Photos</option>
                                <option value="Files">Files</option>
                                <option className={this.state.canViewInvoices ? "" : "hidden"} value="Invoices">Invoices</option>
                                
                                <option value="Notes">Notes</option>
                            </select>
                        </label>
                    </div>

                    <div className="tabsComponent__tabs tabsComponent__hideTabs">
                        <input type="radio" name="tabs" id="tab1" className="tabsComponent__control" checked={this.state.tab == 'Details'} onChange={(e) => this.noChange(e)}></input>
                        <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Details')}>Details</label>

                        <input type="radio" name="tabs" id="tab2" className="tabsComponent__control" checked={this.state.tab == 'Quote'} onChange={(e) => this.noChange(e)}></input>
                        <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Quote')}>Quote</label>

                        <input type="radio" name="tabs" id="tab3" className="tabsComponent__control" checked={this.state.tab == 'Schedule'} onChange={(e) => this.noChange(e)}></input>
                        <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Schedule')}>Schedule</label>

                        <input type="radio" name="tabs" id="tab4" className="tabsComponent__control" checked={this.state.tab == 'Photos'} onChange={(e) => this.noChange(e)}></input>
                        <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Photos')}>Photos</label>

                        <input type="radio" name="tabs" id="tab5" className="tabsComponent__control" checked={this.state.tab == 'Files'} onChange={(e) => this.noChange(e)}></input>
                        <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Files')}>Files</label>

                        <input type="radio" name="tabs" id="tab6" className={this.state.canViewInvoices ? "tabsComponent__control" : "hidden"} checked={this.state.tab == 'Invoices'} onChange={(e) => this.noChange(e)}></input>
                        <label className={this.state.canViewInvoices ? "tabsComponent__label" : "hidden"} htmlFor="tabItem" onClick={() => this.tabSelected('Invoices')}>Invoices</label>
                        
                        <input type="radio" name="tabs" id="tab7" className="tabsComponent__control" checked={this.state.tab == 'Notes'} onChange={(e) => this.noChange(e)}></input>
                        <label className="tabsComponent__label" htmlFor="tabItem" onClick={() => this.tabSelected('Notes')}>Notes</label>
                    </div>

                    <div className="tabsComponent__content tabsComponent__content--selected">
                        <div>
                            {contents}
                        </div>
                    </div>

                </div>

            </div>


        );
    }

}